import React from "react"

const Footer = () => (
  <footer>
    <small>&copy; {new Date().getFullYear()}</small>
  </footer>
)

export default Footer
